import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';

@Component({
    selector: 'fuse-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .fuse-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class FuseConfirmationDialogComponent {
    /* B-302 — SECURITY. `message` is bound with [innerHTML] and used to be run
       through `bypassSecurityTrustHtml`, which turns Angular's sanitiser OFF.
       Nine call sites interpolate user-controlled project, file and template
       names into that string, so a name containing markup executed in the
       browser of whoever opened the delete/overwrite confirmation — a different
       user, on shared dev and prod.

       Stock Fuse binds this sanitised; the bypass was added locally in
       b65f1ba5. Removing it restores the default. Angular's sanitiser keeps the
       safe formatting subset (`<strong>`, `<br>`, `<em>`…), so the one caller
       that legitimately formats — settings.component.ts:329's
       `<strong>${levelText}</strong>` — is unaffected, while scripts, event
       handlers and `javascript:` URLs are stripped.

       If a dialog ever genuinely needs unsanitised markup, add an explicit
       opt-in field for it. Do NOT reinstate the blanket bypass: it makes the
       dangerous case the default for all nine callers. */
    data: FuseConfirmationConfig = inject(MAT_DIALOG_DATA);
}
